import { Dropdown } from '@fluentui/react';
import React, { useCallback, useMemo } from 'react';
import { useLotsCommerciaux, useLotsCommerciauxManager } from '../../../contexts/lotCommercialContext';
import { useResponsiveSize } from '../../../contexts/responsiveContext';

const NavBarDropdown = () => {

    const { lotsCommerciaux } = useLotsCommerciaux();
    const { navBarMaxItems } = useResponsiveSize();
    const { updateLotCommercialActif } = useLotsCommerciauxManager();

    const styles = {
        callout: {
            borderBottom: "2px solid #C4C4C4",
            borderRight: "2px solid #C4C4C4",
            boxShadow: "unset",
        },
        caretDown: { display: "none" },
        dropdown: { selectors: { "&:focus::after": { border: "none" } } },
        dropdownItem: { selectors: { "& > span": { justifyContent: "center" } } },
        title: { border: "none" },
        root: {
            paddingBottom: 14,
            textAlign: "center",
            width: 120,
        },
    };

    const options = useMemo(
        () => {
            return lotsCommerciaux.slice(navBarMaxItems).map((lot => {
                const { idLotCommercial, idOperation, nomCommercial, numero } = lot;
                return {
                    idOperation,
                    idLotCommercial,
                    key: [idOperation, idLotCommercial].join(";"),
                    text: [numero, nomCommercial].join(" - "),
                };
            }));
        },
        [lotsCommerciaux, navBarMaxItems]
    );

    const onChange = useCallback((_, option) => {
        const { idLotCommercial, idOperation } = option;
        updateLotCommercialActif(idOperation, idLotCommercial);
    }, [updateLotCommercialActif]);

    if (options.length === 0) return null;
    return <Dropdown
        dropdownWidth={240}
        onChange={onChange}
        options={options}
        placeholder="..."
        styles={styles}
        selectedKey={null}
    />

};

export default NavBarDropdown;